import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { trustPassportApi } from '@/api/trust-passport';

export function useTrustPassport() {
  return useQuery({
    queryKey: ['trust-passport'],
    queryFn: () => trustPassportApi.get(),
  });
}

export function useRefreshTrustPassport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => trustPassportApi.refresh(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['trust-passport'] });
    },
  });
}
